import { CHANGE_SUB_LIST_TYPE } from './constants'
import type { ChangeSubListTypeAction, ChangeSubListTypePayload } from './types'

export function changeSubListType(payload: ChangeSubListTypePayload): ChangeSubListTypeAction {
  return {
    type: CHANGE_SUB_LIST_TYPE,
    payload,
  }
}
